import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import { MicOffIcon, MicOnIcon } from '../../images';
import { useTrackEnabled } from '../../twilio/hooks';

const AudioIndicator = ({ member, ...props }) => {
  const name = member && member.name;
  const trackSelector = useCallback(
    (track, participant) => {
      return participant.identity === name && track.kind === 'audio';
    },
    [name]
  );
  const isAudioEnabled = useTrackEnabled(trackSelector);

  return <Box {...props}>{isAudioEnabled ? <MicOnIcon /> : <MicOffIcon />}</Box>;
};

AudioIndicator.propTypes = {
  member: PropTypes.object,
};

export default AudioIndicator;
